module.exports = __webpack_public_path__ + "static/img/banner2.90c5283.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner2.jpg
// module id = UsdT
// module chunks = 0